import React, { useState } from "react";
import Sidebar from "../components/BrokerForm/Sidebar";
import StepHeader from "../components/BrokerForm/StepHeader";
import Applicants from "../components/BrokerForm/Applicants";
import Property from "../components/BrokerForm/Property";
import IncomeExpenses from "../components/BrokerForm/IncomeExpenses";
import AssetsLiabilities from "../components/BrokerForm/AssetsLiabilities";
import WorkshopDeal from "../components/BrokerForm/WorkshopDeal";

function BrokerDashboard() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <Sidebar step={step} setStep={setStep} />
      <div style={{ flex: 1, padding: "20px" }}>
        <StepHeader formData={formData} />
        {step === 1 && <Applicants formData={formData} setFormData={setFormData} />}
        {step === 2 && <Property formData={formData} setFormData={setFormData} />}
        {step === 3 && <IncomeExpenses formData={formData} setFormData={setFormData} />}
        {step === 4 && <AssetsLiabilities formData={formData} setFormData={setFormData} />}
        {step === 5 && <WorkshopDeal formData={formData} />}
      </div>
    </div>
  );
}

export default BrokerDashboard;
